// extracted by mini-css-extract-plugin
export default {"iconHeader":"ModalApurarResultado_iconHeader__NaA9I","form":"ModalApurarResultado_form__V5msn","containerButtons":"ModalApurarResultado_containerButtons__rjwtd"};